module.exports = __webpack_public_path__ + "img/job-icon.c3c28a44.svg";